import {
  Button,
  Heading,
  Text,
  VerificationInput,
  VStack,
} from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

export type EmailVerificationProps = {
  email: string
  /** Called automatically when the max code length has been entered */
  onComplete: (code: string) => void
  /** Called when `Resend code` button is clicked */
  onResend: () => void
}

const CODE_LENGTH = 6

export const EmailVerification = ({
  email,
  onComplete,
  onResend,
}: EmailVerificationProps) => {
  const { formatMessage } = useContent()

  const handleChange = (code: string) => {
    if (code.length === CODE_LENGTH) {
      onComplete(code)
    }
  }

  return (
    <CardPage trackingName="EmailVerification">
      <VStack spacing={3} mb={16} textAlign="center">
        <Text fontSize="small" lineHeight="small">
          {formatMessage({ id: 'pmportal.onboarding.stepX' }, { x: 1 })}
        </Text>
        <Heading
          as="h1"
          fontSize="3xlarge"
          lineHeight="3xlarge"
          whiteSpace="pre-line"
        >
          {formatMessage({ id: 'pmportal.onboarding.verifyEmailTitle' })}
        </Heading>
        <Text fontSize="small" lineHeight="small" color="grayscale.secondary">
          {formatMessage(
            { id: 'pmportal.onboarding.verifyEmailDescription' },
            {
              emailText: () => (
                <Text as="span" fontWeight="medium">
                  {email}
                </Text>
              ),
            }
          )}
        </Text>
      </VStack>

      <VStack spacing={3}>
        <VerificationInput length={CODE_LENGTH} onChange={handleChange} />
        <Button variant="ghost" size="xs" onClick={onResend}>
          {formatMessage({ id: 'pmportal.onboarding.verifyEmailResend' })}
        </Button>
      </VStack>
    </CardPage>
  )
}
